import { GenericBaseModel, IGenericBaseModel } from "models/shared/GenericBaseModel";
import { ContainerAllocationModel } from "models/allocation/entities/ContainerAllocationModel";
import { CustomerModel } from "models/user/customer/entities/CustomerModel";
import { OrganizationModel } from "models/company/entities/OrganizationModel";
import { StatusModel } from "models/allocation/entities/StatusModel";
import { LockerSimpleModel } from "models/locker/entities/LockerSimpleModel";



export interface IAllocationModel extends IGenericBaseModel {
    code: string;
    externalCode?: string;
    qrCode: string;

    dateToAllocate?: string;
    dateAllocated?: string;
    dateRetrieved?: string;
    dateReturned?: string;
    dateReturnPickedUp?: string;
    dateMessageNotification?: string;
    dateEmailNotification?: string;

    organization?: OrganizationModel;
    locker: LockerSimpleModel;
    status?: StatusModel;
    // userAllocated: CustomerModel;
    customer: CustomerModel;
    containerAllocations: ContainerAllocationModel[];
    containerAllocationsReturn: ContainerAllocationModel[];
}


export class AllocationModel extends GenericBaseModel {
    code: string;
    externalCode?: string;
    qrCode: string;

    dateToAllocate?: string;
    dateAllocated?: string;
    dateRetrieved?: string;
    dateReturned?: string;
    dateReturnPickedUp?: string;
    dateMessageNotification?: string;
    dateEmailNotification?: string;

    organization?: OrganizationModel;
    locker: LockerSimpleModel;
    status?: StatusModel;
    customer: CustomerModel;

    containerAllocations: ContainerAllocationModel[];
    containerAllocationsReturn: ContainerAllocationModel[];

    constructor(data: IAllocationModel) {
        super(data);

        this.code = data.code;
        this.externalCode = data.externalCode;
        this.qrCode = data.qrCode;

        this.dateToAllocate = data.dateToAllocate;
        this.dateAllocated = data.dateAllocated;
        this.dateRetrieved = data.dateRetrieved;
        this.dateReturned = data.dateReturned;
        this.dateReturnPickedUp = data.dateReturnPickedUp;
        this.dateMessageNotification = data.dateMessageNotification;
        this.dateEmailNotification = data.dateEmailNotification;

        if (typeof data.organization === 'object')
            this.organization = new OrganizationModel(data.organization);
        if (data.status)
            this.status = new StatusModel(data.status);
        this.locker = new LockerSimpleModel(data.locker);

        // this.userAllocated = new CustomerModel(data.userAllocated);
        this.customer = new CustomerModel(data.customer);
        this.containerAllocations = data.containerAllocations.map(i => new ContainerAllocationModel(i));
        this.containerAllocationsReturn = data.containerAllocationsReturn
            ? data.containerAllocationsReturn.map(i => new ContainerAllocationModel(i))
            : [];
    }

    getContainerAllocationsToRetrieve(): ContainerAllocationModel[] {
        const result = this.containerAllocations.filter((i) => i.inLocker && !i.failed);
        return result;
    }

    getContainerAllocationsReturnToRetrieve(): ContainerAllocationModel[] {
        const result = this.containerAllocationsReturn.filter((i) => i.inLocker && !i.failed);
        return result;
    }

    getContainerAllocationsToAllocate(): ContainerAllocationModel[] {
        const result = this.containerAllocations.filter((i) => !i.inLocker);
        return result;
    }
}